import { action, observable } from "mobx";

import apiUrl from "@const/apiUrl";
import baseState from "../../baseState";

export default class aggServerState extends baseState {
  @observable list = {};
  @action
  setList = data => this.list = data;

  getList = data => {
    return this.fetch({
      url: apiUrl.AGGSERVER.LIST,
      method: 'get',
      setState: this.setList,
      data
    });
  }

  add = data => {
    return this.fetch({
      url: apiUrl.AGGSERVER.ADD,
      data
    });
  }

  update = data => {
    return this.fetch({
      url: apiUrl.AGGSERVER.UPDATE,
      data
    });
  }

  delAgg = id => {
    return this.fetch({
      url: apiUrl.AGGSERVER.DELETE + id,
      data: { id }
    });
  }
}
